
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-sample-storage",
      function () {
        return require("private-next-pages/product-sample-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-sample-storage"])
      });
    }
  